var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dp-no-data"},[_c('div',{staticClass:"dp-no-data__image"},[_c('dp-icon',{attrs:{"name":"question"}})],1),_c('div',{staticClass:"dp-no-data__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }